import {compareAsc, format, parse} from 'date-fns';
import {ptBR} from 'date-fns/locale';

export function sortDateStringArray(dateArr: string[]) {
	const parsedDates = dateArr.map(date =>
		parse(date, 'P', new Date(), {
			locale: ptBR,
		}),
	);

	const sortedDates = parsedDates.toSorted(compareAsc);
	const stringfiedDates = sortedDates.map(date => format(date, 'P', {locale: ptBR}));

	return stringfiedDates;
}
